import { render, staticRenderFns } from "./FluxIndex.vue?vue&type=template&id=aa10287e&"
import script from "./FluxIndex.vue?vue&type=script&lang=js&"
export * from "./FluxIndex.vue?vue&type=script&lang=js&"
import style0 from "./FluxIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports